<div [formGroup]="statisticsService.form" class="flex flex-col min-w-0 w-full">
  <ng-container *ngIf="input.type == 'calendar'">
    <mat-label>{{input.label | translate }}</mat-label>
    <mat-form-field (click)="preventDefault($event)" class="w-full min-w-0" appearance="outline">
      <mat-date-range-input class="w-full min-w-0" [formGroupName]="input.formControlName" [rangePicker]="picker">
        <input
          matStartDate
          [formControlName]="input.formGroup[0].formControlName"
          [placeholder]="input.formGroup[0].placeholder | translate" />
        <input
          matEndDate
          [formControlName]="input.formGroup[1].formControlName"
          [placeholder]="input.formGroup[1].placeholder | translate" />
      </mat-date-range-input>
      <app-icon
        class="absolute cursor-pointer right-0 top-[13px]"
        (click)="clearDatePicker(input.formControlName, input.type == 'calendar')"
        size="md"
        iconName="close"></app-icon>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </ng-container>
  <div *ngIf="input.type == 'datepicker'">
    <mat-label>{{ input.label | translate }} *</mat-label>
    <mat-form-field (click)="preventDefault($event)" class="flex items-center w-full min-w-0">
      <input
        matInput
        [matDatepicker]="picker"
        [formControlName]="input.formControlName"
        [min]="input.formControlName === 'end' ? statisticsService.form.get('start').value?.toString() : null"
        [max]="input.formControlName === 'start' ? statisticsService.form.get('end').value?.toString() : null"
        (dateChange)="onFilterChange(input.formControlName)" />
      <button
        class="absolute right-8"
        mat-icon-button
        matSuffix
        type="button"
        (click)="clearDatePicker(input.formControlName, input.type == 'calendar')"
        *ngIf="statisticsService.form.get(input.formControlName).value">
        <mat-icon>clear</mat-icon>
      </button>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
